import { apiRequest } from './client';
import type { MeView } from './types';

export interface RegisterPayload {
  email: string;
  password: string;
  name?: string | null;
  installationId?: number | null;
  inviteToken?: string | null;
}

export interface LoginPayload {
  email: string;
  password: string;
}

export interface AuthSuccess {
  token: string;
  expiresAt: string;
  user: MeView;
}

export const auth = {
  me: () => apiRequest<MeView>('/api/auth/me'),
  login: (payload: LoginPayload) =>
    apiRequest<AuthSuccess>('/api/auth/login', { method: 'POST', body: payload }),
  logout: () => apiRequest<void>('/api/auth/logout', { method: 'POST' }),
  register: (payload: RegisterPayload) =>
    apiRequest<AuthSuccess>('/api/auth/register', { method: 'POST', body: payload }),
  verifyEmail: (token: string) =>
    apiRequest<void>('/api/auth/verify-email', { method: 'POST', body: { token } }),
  resendVerification: () =>
    apiRequest<void>('/api/auth/resend-verification', { method: 'POST' }),
  forgotPassword: (email: string) =>
    apiRequest<void>('/api/auth/forgot-password', { method: 'POST', body: { email } }),
  resetPassword: (token: string, newPassword: string) =>
    apiRequest<void>('/api/auth/reset-password', { method: 'POST', body: { token, newPassword } }),
};
